export const SET_OPEN_VENUES_FOR_BREAKFAST = 'SET_OPEN_VENUES_FOR_BREAKFAST';
export const SET_OPEN_VENUES_FOR_DINNER = 'SET_OPEN_VENUES_FOR_DINNER';
